import settings from '@/config/settings';

export default {
  namespaced: true,
  state: {
    ...settings
  },
  mutations: {
    setLang(state, lang) {
      state.lang = lang;
    }
  }
}
